<template>
  <list-card
    ref="refList"
    :items="items"
    :list-actions="listActions"
    :group-actions="groupActions"
    :filters="filters"
    :sorting="sorting"
    :current-sort-by="currentSortId"
    title="Connections"
    @click:sort="handleSort"
    @click:filter="handleFilter"
    @selectedItemIds="handleSelectedItemIds"
  >
    <template #item="{select,index, ...props}">
      <connection-list-item
        v-testid="`conection-list-item-${index}`"
        v-bind="props"
        :actions="getItemActions(props.item)"
        :to="getItemRoute(props.item)"
        @select="select"
      />
    </template>
  </list-card>
</template>

<script>
import ListCard from '@/components/list-card';
import ConnectionListItem from './ConnectionListItem';
import { useObjectListActions } from './listActions';
import { useObjectFilterMenu } from './filterMenu';

import { computed, ref } from '@vue/composition-api';

import { useSortBy } from '@/compositions/sortBy';
import { useFilterBy } from '@/compositions/filterBy';
import { useConnectionMenu } from '@/modules/connections/compositions/connectionMenu';
import { useConnections } from '@/modules/connections/compositions/connections';
import sortingMenu from './sortingMenu';
import ObjectListItem from '@/modules/objects/ui/object-list/ObjectListItem.vue';

export default {
  name: 'Connections',
  components: {
    ObjectListItem,
    ListCard,
    ConnectionListItem
  },

  setup(props, { root }) {
    const refList = ref(null);
    const { list } = useConnections();

    const clearSelection = () => {
      refList.value && refList.value.clearSelection();
    };

    const getItemRoute = item => ({
      name: 'connection_card',
      params: {
        connectionId: item.id
      },
      query: root.$route.query
    });

    const selectedIds = ref([]);

    const getItemActions = entity => {
      return useConnectionMenu({ entity });
    };

    const keyword = computed(() => {
      return root.$route?.query?.keyword;
    });

    const searchedList = computed(() => {
      return keyword.value
        ? list.value.filter(i =>
            i.name.toLowerCase().includes(keyword.value.toLowerCase())
          )
        : list.value;
    });

    const {
      menuItems: filters,
      handleFilter,
      filterFunctions
    } = useObjectFilterMenu();

    const { filteredItems } = useFilterBy(searchedList, filterFunctions);

    const { sortedItems, currentSortId, handleSort } = useSortBy(
      filteredItems,
      sortingMenu,
      'connection'
    );

    const { listActions } = useObjectListActions();

    const handleSelectedItemIds = ids => {
      selectedIds.value = ids;
    };

    const groupActions = [
      // genMenuItemDelete(() => {
      //   popup.openConfirm({
      //     component: () => import('@/components/popup/PopupConfirmAction.vue'),
      //     props: {
      //       title: 'Delete these connections completely?',
      //       onConfirm: () => {
      //         linkedObjectService.massiveDelete(
      //           selectedIds.value.map(item => ({ id: item }))
      //         );
      //         clearSelection();
      //       }
      //     }
      //   });
      // })
    ];

    return {
      getItemRoute,
      items: sortedItems,
      getItemActions,
      listActions,
      groupActions,
      filters,
      handleFilter,
      sorting: sortingMenu,
      currentSortId,
      handleSort,
      handleSelectedItemIds,
      list,
      refList
    };
  }
};
</script>

<style></style>
